import React, { useState } from "react";
import { FileText, ChevronDown, ChevronUp } from "lucide-react";

// Reusable, self-contained Notes dropdown for Admin tables
export const NotesDropdown = ({ notes }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!notes) return null;
  return (
    <div className="mt-1">
      <button
        onClick={(e) => { e.stopPropagation(); setIsExpanded((v) => !v); }}
        className="flex items-center gap-1 text-xs text-zinc-400 hover:text-crew-yellow transition-colors"
      >
        <FileText className="w-3 h-3" />
        <span>Notes</span>
        {isExpanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
      </button>
      {isExpanded && (
        <div className="mt-1 p-2 rounded-sm text-xs bg-zinc-800/50 text-zinc-300 max-w-xs">
          {notes}
        </div>
      )}
    </div>
  );
};
